export default {
	props: {
		type: {
			type: String,
			default: 'default'
		}
	},
	computed: {
		classes() {
			return [`alert-${this.type}`]
		}
	}
}
